import React, { FC, memo } from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { IEnvironment } from 'relay-runtime';

import { RoutingContext } from 'app-core';
import { AppAdmin, AppAdminRoutes } from 'app-admin';
import { AppCandidates } from 'app-candidates';
import { AppEmployers, AppEmployerRoutes } from 'app-employers';

import { ErrorPage, RootPage, HomePage } from './pages';

type Props = {
  basename: string;
  environment: IEnvironment;
  routingContext: RoutingContext;
};

export const AppRoutes: FC<Props> = ({
  basename,
  environment,
  routingContext,
}) => {
  const router = createBrowserRouter(
    [
      {
        element: <RootPage />,
        errorElement: <ErrorPage />,
        children: [
          {
            path: 'admin/*',
            element: <AppAdmin />,
            errorElement: <ErrorPage />,
            children: AppAdminRoutes(environment, routingContext),
          },
          {
            path: 'candidates/*',
            element: <AppCandidates />,
            errorElement: <ErrorPage />,
          },
          {
            path: 'employers/*',
            element: <AppEmployers />,
            errorElement: <ErrorPage />,
            children: AppEmployerRoutes(environment, routingContext),
            handle: {},
          },
          {
            path: '*',
            element: <HomePage />,
            errorElement: <ErrorPage />,
          },
        ],
      },
    ],
    {
      basename: `/${basename}`,
    },
  );

  return <RouterProvider router={router} />;
};

export default memo(AppRoutes);
